<div class="progress">
  @for (item of steps; track item; let last = $last) {
    <div class="progress-item">
      @if (item.type === 'static') {
        <div>
          <div class="step-container">
            <div class="step" [ngClass]="{'selected': isCurrentStep(item.step), 'active': item.active}">{{item.step}}</div>
            <div class="label">{{item.label}}</div>
            @if (!last) {
              <div class="spacer"></div>
            }
          </div>
        </div>
      }
      @if (item.type === 'link') {
        <div>
          <a [routerLink]="item.path">
            <div class="step-container">
              <div
                class="step"
                [ngClass]="{'selected': isCurrentStep(item.step), 'active': item.active || !isCurrentStep(item.step)}"
              >{{item.step}}</div>
              <div class="label">
                {{item.label}}
              </div>
              @if (!last) {
                <div class="spacer"></div>
              }
            </div>
          </a>
        </div>
      }
    </div>
  }
</div>
